import TokenizedSequencesContract from './contracts/TokenizedSequencesContract.js';
import {TokenizedSequenceEdited, Transfer} from 'decentralized/EthereumEvents.js';
import BackendQuery from 'decentralized/BackendQuery.js';
import accounts from 'accounts/Accounts.js';
import EthereumTransaction from 'decentralized/transactions/EthereumTransaction.js';
import {TOKENIZED_SEQUENCES} from 'decentralized/transactions/contracts.js';
import ethereum from 'decentralized/ethereum.js';
import {SEQUENCE_USED_SOUND} from 'decentralized/xanadu/LinkTypes.js';
import {ipfsHashToBytes32} from 'utils/ipfsHash';

const contract = new TokenizedSequencesContract();

class TokenizedSequences {
    constructor(web3) {
        this.web3 = web3;
        this.contract = new web3.eth.Contract(
            contract.abi,
            contract.contractAddress);
        this.contractAddress = this.contract.options.address;
        this.zero = this.web3.utils.padRight("0x00", 64);
    }

    async getPrice() {
        return await this.contract.methods.getPrice().call();
    }

    async buyTokens(numTokens) {
        numTokens = Math.pow(10, 3) * numTokens;
        let price = await this.getPrice(); 
        let value = price * numTokens;
        new EthereumTransaction(
            TOKENIZED_SEQUENCES, 'buyTokens', [numTokens], value).
            execute();
    }

    async getBalance() {
        console.log('get balance called');
        const account = await accounts.getAccount();
        if (account === undefined) {
            return 0;
        }
        let balance = await this.contract.methods.balanceOf(account).call();
        return parseFloat(balance) / 1000;

    }

    saveNewSequence(previousSequence, newSequence, title, samples) {
        return new Promise(async (resolve, reject) => {
            const account = await accounts.getAccount();
            if (account === undefined) {
                resolve();
            }

            let sampleHashes = [];
            for (let i in samples) {
                sampleHashes.push(ipfsHashToBytes32(samples[i]));
            }
            previousSequence = previousSequence === undefined ?
                this.zero :
                ipfsHashToBytes32(previousSequence);
            newSequence = ipfsHashToBytes32(newSequence);

            // first link the sequence to the sounds
            // TODO: create a bulk contract method for this, so that we dont do
            // 10+ transactions for a single project
            /*
            sampleHashes.forEach(
                hash => 
                    ethereum.xanadu.newLinks(SEQUENCE_USED_SOUND, newSequence, hash));
                    */

            sampleHashes.push(previousSequence);
            new EthereumTransaction(
                TOKENIZED_SEQUENCES, 'editSequence',
                [previousSequence, newSequence, title, sampleHashes])
                .execute()
                .then(transactionHash => resolve)
                .catch(err => reject);
        });
    }

    getSequences(user, fromBlock, toBlock, ids) {
        return new Promise(async (resolve, reject) => {
            let sequencesQuery = new BackendQuery(this.contractAddress)
                .select('user')
                .select('previousSequence')
                .select('newSequence')
                .select('title')
                .fromBlock(fromBlock)
                .toBlock(toBlock)
                .from(TokenizedSequenceEdited);

            if (user !== undefined) {
                sequencesQuery.where('user', user.toLowerCase());
            }

            if (ids) {
                sequencesQuery.whereIn("newSequence", ids);
            }

            let sequences = await sequencesQuery.executeQuery(false);
            sequences.sort((a,b) => b.blockNumber - a.blockNumber);
            resolve(sequences.map(sequence => ({... sequence, edits: 0})));
        }); 
    }

    async getNextSequences(ipfsHash) {
        return new Promise(async (resolve, reject) => {
            let sequencesQuery = new BackendQuery(this.contractAddress)
                .select('user')
                .select('previousSequence')
                .select('newSequence')
                .select('title')
                .where('previousSequence', ipfsHash)
                .from(TokenizedSequenceEdited);

            let sequences = await sequencesQuery.executeQuery();
            resolve(sequences.map(sequence => ({... sequence, edits: 0})));
        }); 
    }

    async getPreviousSequences(ipfsHash) {
        return new Promise(async (resolve, reject) => {
            console.log('getPreviousSequence(' + ipfsHash + ')');
            let sequencesQuery = new BackendQuery(this.contractAddress)
                .select('user')
                .select('previousSequence')
                .select('newSequence')
                .select('title')
                .where('newSequence', ipfsHash)
                .from(TokenizedSequenceEdited);

            let sequences = await sequencesQuery.executeQuery();
            sequences = sequences.map(sequence => ({... sequence, edits: 0, isPrevious: true}));
            if (sequences.length === 0 || sequences[0].previousSequence === ipfsHash) {
                resolve(sequences);
            } else {
                let first = sequences[0].previousSequence;
                resolve([... sequences, ... await this.getPreviousSequences(first)]);
            }
        }); 
    }

    async getSequence(ipfsHash) {
        return new Promise(async (resolve, reject) => {
            console.log('getSequence(' + ipfsHash + ')');
            let sequencesQuery = new BackendQuery(this.contractAddress)
                .select('user')
                .select('previousSequence')
                .select('newSequence')
                .select('title')
                .where('newSequence', ipfsHash)
                .from(TokenizedSequenceEdited);

            let sequences = await sequencesQuery.executeQuery();
            console.log("TOKENIZED SEQ =", sequences);
            resolve(sequences.map(sequence => ({... sequence, edits: 0})));
        }); 
    }

    async watchBalance() {
        let account = await accounts.getAccount();
        if (account === undefined) {
            return;
        }

        console.log('watch balance toUser = ' + account);
        let query = new BackendQuery(this.contract.options.address)
            .from(Transfer)
            .select('amount')
            .where('toUser', account.toLowerCase());

        query.watchQuery((result) => {
            if (this.callback) {
                this.callback();
            }
        });
    }
}

export default TokenizedSequences;
